import React from 'react';
import { Card, Form, Select, Input, Row, Col, Space } from 'antd';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;
const { TextArea } = Input;

interface HandicapProps {
  form: FormInstance;
}

const Handicap: React.FC<HandicapProps> = ({ form }) => {
  const handicapTypeOptions = ['Mental', 'Physical'];
  const disabilityAffectsOptions = [
    'Learning', 'Walking', 'Seeing', 'Hearing', 
    'Speaking', 'Breathing', 'Working', 'Other'
  ];
  const yesNoOptions = ['Yes', 'No'];
  const howLearnedOptions = [
    'You provided the information in writing',
    'You told the accused verbally',
    'Medical records were provided',
    'Other'
  ];

  return (
    <Card title="Handicap Information" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="What type of handicap do you have?"
            name={['handicap_info', 'handicap_type']}
          >
            <Select placeholder="Select handicap type">
              {handicapTypeOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Your disability affects your:"
            name={['handicap_info', 'disability_affects']}
          >
            <Select placeholder="Select how it affects you">
              {disabilityAffectsOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Are you generally considered handicapped by other employees?"
            name={['handicap_info', 'generally_considered_handicapped']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Was the accused aware of your handicap?"
            name={['handicap_info', 'accused_aware_of_handicap']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Date the accused learned of your handicap"
            name={['handicap_info', 'date_accused_learned']}
          >
            <Input placeholder="MMDDYY" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="How did he learn of it?"
            name={['handicap_info', 'how_accused_learned']}
          >
            <Select placeholder="Select">
              {howLearnedOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Is the accused handicapped?"
            name={['handicap_info', 'accused_handicapped']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="What type of handicap does the accused have?"
            name={['handicap_info', 'accused_handicap_type']}
          >
            <Select placeholder="Select handicap type">
              {handicapTypeOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="What is the accused's handicap?"
            name={['handicap_info', 'accused_handicap_description']}
          >
            <TextArea rows={2} placeholder="Describe accused's handicap" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Were you qualified for the job?"
            name={['handicap_info', 'qualified_for_job']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Does your handicap prevent you from performing your job requirements?"
            name={['handicap_info', 'handicap_prevents_job_performance']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default Handicap;

